import { useMemo } from 'react'
import moment from 'moment'

const GHOST_MESO_VOLUME_ID = 'GHOST_MESO_VOLUME'

export default function MacroVolumePhaseTimelineDisplay({
    renderRangeStart,
    renderRangeEnd,
    daySpacing = 0,
    macroVolumePhaseTypeHashMap = {},
    macroVolumePhases = [],
    mesoVolumes = [],
    DateToTrackLeftX = () => { return 0 }
}) {

    const marcoVolumeDisplayData = useMemo(() => {
        if (daySpacing <= 0) {
            return []
        }

        const newMarcoVolumeDisplayData = []

        macroVolumePhases.forEach((macroVolumePhase) => {
            const startDate = moment(macroVolumePhase.startDate).startOf('day')
            const endDate = moment(macroVolumePhase.endDate).startOf('day')

            if (
                !startDate.isValid()
                || !endDate.isValid()
                || endDate.isBefore(renderRangeStart, 'day')
                || startDate.isAfter(renderRangeEnd, 'day')
            ) {
                return
            }

            const left = DateToTrackLeftX(startDate)
            const width = DateToTrackLeftX(endDate.clone().add(1, 'day')) - left

            newMarcoVolumeDisplayData.push({
                left,
                width,
                isGhostWeek: false,
                macroVolumePhaseTypeId: macroVolumePhase.macroVolumePhaseTypeId,
            })
        })

        // Ghost spacer weeks live on mesoVolumes only — paint matching gray bars here.
        mesoVolumes.forEach((mesoVolume) => {
            if (mesoVolume.mesoVolumeId !== GHOST_MESO_VOLUME_ID) {
                return
            }

            const startDate = moment(mesoVolume.startDate).startOf('day')
            const endDate = moment(mesoVolume.endDate).startOf('day')

            if (
                !startDate.isValid()
                || !endDate.isValid()
                || endDate.isBefore(renderRangeStart, 'day')
                || startDate.isAfter(renderRangeEnd, 'day')
            ) {
                return
            }

            const left = DateToTrackLeftX(startDate)
            const width = DateToTrackLeftX(endDate.clone().add(1, 'day')) - left

            newMarcoVolumeDisplayData.push({
                left,
                width,
                isGhostWeek: true,
                macroVolumePhaseTypeId: null,
            })
        })

        return newMarcoVolumeDisplayData
    }, [
        renderRangeStart,
        renderRangeEnd,
        daySpacing,
        macroVolumePhases,
        mesoVolumes,
        DateToTrackLeftX,
    ])

    if (
        Object.keys(macroVolumePhaseTypeHashMap).length === 0 
        && !marcoVolumeDisplayData.some((item) => item.isGhostWeek)
    ) {
        return <div className='relative h-4 2xl:h-5' />
    }

    return (
        <div className='relative h-4 2xl:h-5'>
            {marcoVolumeDisplayData.map((marcoVolumeDisplay, index) => (
                <div
                    key={index}
                    className='absolute bottom-0 h-4 2xl:h-5 px-[1.5px] 2xl:px-[2px] transition-opacity'
                    style={{
                        left: `${marcoVolumeDisplay.left}px`,
                        width: `${marcoVolumeDisplay.width}px`,
                    }}
                >
                    <div
                        className={`
                            h-full flex items-center justify-center overflow-hidden rounded 
                            ${marcoVolumeDisplay.isGhostWeek ? 'bg-gray-300' : ''}
                        `}
                        style={
                            marcoVolumeDisplay.isGhostWeek ? undefined : {
                                backgroundColor: macroVolumePhaseTypeHashMap[marcoVolumeDisplay.macroVolumePhaseTypeId]?.colorHex,
                            }
                        }
                    >
                        {!marcoVolumeDisplay.isGhostWeek && (
                            <span
                                className='text-xxs 2xl:text-xs font-medium whitespace-nowrap px-1'
                                title={macroVolumePhaseTypeHashMap[marcoVolumeDisplay.macroVolumePhaseTypeId]?.name}
                            >
                                {macroVolumePhaseTypeHashMap[marcoVolumeDisplay.macroVolumePhaseTypeId]?.name}
                            </span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}
